import { FC } from "react";

import useStyles from "@/common/components/LegacyMosaic/Mosaic.styles";
import MosaicItem from "@/common/components/LegacyMosaic/MosaicItem";
import CameraStreamData from "@/utilities/types/cameraStreamData";


interface MosaicProps {
    cameras: CameraStreamData[];
    onCloseCamera?: (cameraId: number) => void;
    liveUnitId: number;
}

const Mosaic: FC<MosaicProps> = ({ cameras, onCloseCamera, liveUnitId }) => {
    const classes = useStyles();

    const isLandscape = window.innerWidth > window.innerHeight;

    return (
        <div className={classes.camerasContainer}>
            {cameras
                .map((camera: CameraStreamData, index) => (
                    <MosaicItem
                        key={camera.cameraId + index}
                        camera={camera}
                        streams={cameras.length}
                        onClose={onCloseCamera ? () => onCloseCamera(camera.cameraId) : undefined}
                        isLandscape={isLandscape}
                        liveUnitId={liveUnitId}
                    />
                ))
            }
        </div>
    );
};

export default Mosaic;
